module.exports = __webpack_public_path__ + "img/frame_logo.e2dd09c0.png";